import { Reachability } from '@aws-amplify/core';
import { useEffect, useState, useRef } from 'react';
export const reachabilityMonitor = new Reachability().networkMonitor();
function useOnlineStatus() {
    const [onlineStatus, setOnlineStatus] = useState();
    const reachability = useRef(reachabilityMonitor.subscribe(v => {
        if (onlineStatus !== v.online) {
            setOnlineStatus(v.online);
        }
    }));
    useEffect(() => () => reachability.current.unsubscribe(), []);
    return onlineStatus;
}
export default useOnlineStatus;
//# sourceMappingURL=useOnlineStatus.js.map